import type { GeomTypeUtil } from "./geomTypeUtil";

const es = global.es; // TODO: Remove dependency!!!

export default class MG implements GeomTypeUtil {
    /**
     * 
     * @param geom 
     * @param callback 
     * @param owner 
     */
    extractPoints(geom: any[], callback: Function, owner?: any) {
        for (let g = geom.length; g-- > 1; ) {
            const subGeom = geom[g];
            es.api.geom.extractPoints(subGeom, callback, owner);
        }
    }
    
    /**
     * 
     * @param geom 
     * @param callback 
     * @param owner 
     */
    extractLines(geom: any[], callback: Function, owner?: any) {
        for (let g = geom.length; g-- > 1; ) {
            const subGeom = geom[g];
            es.api.geom.extractLines(subGeom, callback, owner);
        }
    }
    
    /**
     * 
     * @param geom 
     * @param bounds 
     * @returns 
     */
    getBounds(geom: any[], bounds: number[]): number[] {
        for (let g = 1; g < geom.length; g++) {
            bounds = es.api.geom.getBounds(geom[g], bounds);
        }

        return bounds;
    }
    
    /**
     * 
     * @param geom 
     * @param matrix 
     * 
     * @returns 
     */
    transform(geom: any[], matrix: number[]): any {
        const ret = ["MG"];
        for (let g = 1; g < geom.length; g++) {
            ret[g] = es.api.geom.transform(geom[g], matrix);
        }

        return ret;
    }
    
    /**
     * 
     * @param geom 
     * @param threshold 
     * 
     * @returns 
     */
    generalize(geom: any[], threshold: number): any[] {
        const ret = ["MG"];
        for (let g = 1; g < geom.length; g++) {
            ret[g] = es.api.geom.generalize(geom[g], threshold);
        }

        return ret;
    }
}
